import styled from "styled-components";
import { Body1, H3 } from "../style-comps/Common.styles";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 16px;
  width: 200px;
  height: 180px;
  position: relative;
  gap: 10px;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 150px;
    
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ReviewText = styled(Body1)`
  margin: 0;
`;

export const ProgressBarWrapper = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0;
`;

export const HorseshoeSvg = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  svg {
    width: 100%;
    height: 100%;
  }
`;

export const ScoreText = styled(H3)`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
